import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { useState } from "react";
import toast from "react-hot-toast";
import { db } from "../config/firebase";
import { useNavigate } from "react-router-dom";

export default function Order() {
  const navigate = useNavigate()

  const [name, setName] = useState("");
  const [toppings, setToppings] = useState<string[]>([]);
  const [extra, setExtra] = useState("");

  const handleToppingChange = (topping: string) => {
    setToppings((prevToppings) =>
      prevToppings.includes(topping)
        ? prevToppings.filter((t) => t !== topping)
        : [...prevToppings, topping]
    );
  };

  const submitForm =  async () => {
    if (!name) {
      toast.error('Bitte einen Name eintragen');
      return
    }
    const id = toast.loading('Bestellen...')
    try {
      await addDoc(collection(db, 'orders'), {
        name: name,
        extra: extra,
        toppings: toppings,
        createdAt: serverTimestamp()
      })
      toast.success('Bestellt', { id })
      navigate('/success')
    } catch (error) {
      toast.error('Es ist ein interner Fehler beim Bestellen aufgetreten :(');
      console.error(error)
    }
  }

  return (
    <main className="content">
      <section className="form-section">
        <h1 className="title">🍕 Pizza Bestellen</h1>

        <div className="form-group">
          <label htmlFor="name">Dein Name:</label>
          <input
            id="name"
            type="text"
            placeholder="Name..."
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        <fieldset className="toppings">
          <legend>Wähle deine Beläge:</legend>
          {[
            "Paprika, ",
            "Pilze, ",
            "Zwiebeln, ",
            "Schinken, ",
            "Salami, ",
            "Ananas, ",
            "Rucola, ",
            "Mais, ",
            "Käse, ",
            "Mozzarella, ",
          ].map((belag, i) => (
            <label key={i} className="checkbox">
              <input
                type="checkbox"
                onChange={() => handleToppingChange(belag)}
              />
              {belag}
            </label>
          ))}
        </fieldset>

        <div className="form-group">
          <label htmlFor="extra">Zusatz:</label>
          <small>Willst du noch etwas erwähnen?</small>
          <input
            id="extra"
            type="text"
            placeholder="Zusatz..."
            value={extra}
            onChange={(e) => setExtra(e.target.value)}
          />
        </div>

        <div className="submit-box">
          <button onClick={submitForm} className="submit-btn">
            <span id="finish">Absenden</span>
            <span id="counter"></span>
          </button>
        </div>
      </section>
    </main>
  );
}
